import React from "react";
import useQueryURL from "../../../common/hooks/useQueryURL";
import ModalDrawer from "../../../common/components/organisme/ModalDrawer/ModalDrawer";
import AddManualCreditForm from "../../../features/wallet/components/wallets/AddManualCreditForm/AddManualCreditForm";

export const ADD_MANUAL_CREDIT_MODAL_ID = "add-manual-credit-modal";

export default function AddManualCreditPage({onSuccess}: {onSuccess?: () => void}) {
  return <div>
    <AddManualCreditForm onSuccess={onSuccess} />
  </div>;
}

export const AddManualCreditDrawer = ({
  modalId,
}: {
  modalId?: string;
  children?: React.ReactNode;
}) => {
  const modalIdFound = modalId || ADD_MANUAL_CREDIT_MODAL_ID;
  const { removeQueryValue } = useQueryURL();
  const onClose = () => {
    removeQueryValue([modalIdFound]);
  };

  const onSuccess = () => {
    onClose();
  };

  return (
    <ModalDrawer
      urlParamName={modalIdFound}
      title={"Ajouter du Crédit Manuel"}
      onClose={onClose}
    >
         <AddManualCreditPage onSuccess={onSuccess}  />
    </ModalDrawer>
  );
};
